import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal, { EASE } from "@/components/Reveal";

const AREAS = [
    {
        number: "01",
        title: "Consulenza aziendale, direzionale e marketing",
        text: "Affianchiamo la direzione nelle decisioni strategiche: posizionamento, piani di marketing e sviluppo del business, con un metodo concreto e orientato ai risultati.",
    },
    {
        number: "02",
        title: "Organizzazione aziendale e risorse umane",
        text: "Riorganizziamo strutture, ruoli e processi per far lavorare meglio le persone: dall'analisi dell'organigramma alla valorizzazione del capitale umano.",
    },
    {
        number: "03",
        title: "Formazione professionale, manageriale e personale",
        text: "Progettiamo percorsi formativi su misura per team, manager e professionisti: competenze tecniche, leadership e crescita personale.",
    },
    {
        number: "04",
        title: "Supporto amministrativo e organizzativo",
        text: "Semplifichiamo la gestione quotidiana con supporto amministrativo e organizzativo, così puoi concentrarti su ciò che fa crescere la tua impresa.",
    },
    {
        number: "05",
        title: "Orientamento e sviluppo delle competenze",
        text: "Mappiamo le competenze presenti e quelle necessarie, costruendo percorsi di orientamento e sviluppo per persone e team.",
    },
    {
        number: "06",
        title: "Sviluppo professionale e organizzativo",
        text: "Accompagniamo la crescita di professionisti e organizzazioni nel tempo, con piani di sviluppo costruiti sulla tua realtà.",
    },
];

export default function Aree() {
    const [open, setOpen] = useState(0);

    return (
        <section
            id="aree-competenza"
            data-testid="aree-competenza-section"
            className="bg-[#FAF7F2] py-24 sm:py-32"
        >
            <div className="mx-auto max-w-5xl px-5 sm:px-8">
                <Reveal>
                    <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#B88282]">Attività</p>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-4 max-w-2xl font-serif text-4xl leading-tight tracking-tight sm:text-5xl">
                        Sei aree di competenza, un unico <span className="italic text-[#B88282]">obiettivo</span>.
                    </h2>
                </Reveal>

                <div className="mt-16">
                    {AREAS.map((a, i) => {
                        const isOpen = open === i;
                        return (
                            <Reveal key={a.number} delay={0.05 * i}>
                                <div className="border-b border-[#1A1A1A]/10 first:border-t">
                                    <button
                                        data-testid={`accordion-trigger-${a.number}`}
                                        onClick={() => setOpen(isOpen ? -1 : i)}
                                        aria-expanded={isOpen}
                                        className="group flex w-full items-center gap-5 py-7 text-left sm:gap-8"
                                    >
                                        <span className="text-outline-rose w-10 shrink-0 select-none font-serif text-3xl font-bold sm:w-14 sm:text-4xl">
                                            {a.number}
                                        </span>
                                        <span className="flex-1 font-serif text-xl leading-snug transition-colors duration-300 group-hover:text-[#B88282] sm:text-2xl">
                                            {a.title}
                                        </span>
                                        <motion.span
                                            animate={{ rotate: isOpen ? 45 : 0 }}
                                            transition={{ duration: 0.4, ease: EASE }}
                                            className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full border transition-colors duration-300 ${
                                                isOpen
                                                    ? "border-[#D4A5A5] bg-[#D4A5A5] text-[#1A1A1A]"
                                                    : "border-[#1A1A1A]/15 text-[#1A1A1A] group-hover:border-[#D4A5A5] group-hover:text-[#B88282]"
                                            }`}
                                        >
                                            <Plus className="h-4 w-4" />
                                        </motion.span>
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.5, ease: EASE }}
                                                className="overflow-hidden"
                                            >
                                                <p
                                                    data-testid={`accordion-content-${a.number}`}
                                                    className="max-w-3xl pb-8 pl-[3.75rem] pr-6 text-sm leading-relaxed text-[#5A5A5A] sm:pl-[5.5rem] sm:text-base"
                                                >
                                                    {a.text}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
